/**
 * Google Maps config shared by the directory map (Maps JavaScript API) and the
 * single-location iframes (Maps Embed API) — issue #97.
 *
 * One browser key, restricted in GCP (project fixdelivered-3c812, "Maps browser
 * key") to those two APIs and to our domains by HTTP referrer. Browser keys ship
 * in the bundle by design; the restrictions are what protect them. Never use the
 * server-side Places/Geocoding keys here.
 *
 * Billing: the Embed API is free. The JavaScript API bills per map load
 * (10k/month free, then ~$7 per 1,000), so PlumberMap only creates its map once
 * it scrolls near the viewport.
 */
function readEnv(value: string | undefined): string | undefined {
  return value?.trim() || undefined
}

export const GOOGLE_MAPS_API_KEY = readEnv(import.meta.env['VITE_GOOGLE_MAPS_API_KEY'])

/** Advanced markers need a map ID. DEMO_MAP_ID is Google's shared default style;
 *  create one under Maps Platform → Map management and set the variable to own
 *  the styling. */
export const GOOGLE_MAPS_MAP_ID = readEnv(import.meta.env['VITE_GOOGLE_MAPS_MAP_ID']) ?? 'DEMO_MAP_ID'
